export * from './libs/institution-table-component';
export * from './libs/institution-import-table';
export * from './libs/institution-detail-branches';
export * from './libs/institution-detail-content';
export * from './libs/institution-detail-products';
export * from './libs/institution-detail-profile';
export * from '../../../../../apps/crm/src/pages/institution/libs/institution-detail';
